import placeholder from '@/assets/medication-placeholder.webp';
import { CartItem, useCartStore } from '@/store/cartStore';
import {
  Delete01Icon,
  MinusSignIcon,
  PlusSignIcon,
} from '@hugeicons/core-free-icons';
import { HugeiconsIcon } from '@hugeicons/react';

interface CartItemRowProps {
  item: CartItem;
}

export function CartItemRow({ item }: CartItemRowProps) {
  const updateQuantity = useCartStore(s => s.updateQuantity);
  const removeItem = useCartStore(s => s.removeItem);

  const handleDecrease = () => {
    if (item.quantity > 1) {
      updateQuantity(item.id, item.quantity - 1);
    } else {
      removeItem(item.id);
    }
  };

  const handleIncrease = () => {
    updateQuantity(item.id, item.quantity + 1);
  };

  const displayImage = item.image || placeholder;

  return (
    <div className="flex justify-between items-center">
      <div className="flex items-center gap-3">
        <img
          src={displayImage}
          alt={item.title}
          className="w-10 h-10 object-cover rounded-md flex-shrink-0"
          onError={e => {
            e.currentTarget.src = placeholder;
          }}
        />
        <div className="min-w-0">
          <p className="text-sm font-medium truncate">{item.title}</p>
          <div className="flex items-center gap-1. 5 mt-0.5">
            <button
              type="button"
              onClick={handleDecrease}
              className="w-5 h-5 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
              aria-label={
                item.quantity === 1 ? 'Remove item' : 'Decrease quantity'
              }
            >
              {item.quantity === 1 ? (
                <HugeiconsIcon icon={Delete01Icon} size={12} />
              ) : (
                <HugeiconsIcon icon={MinusSignIcon} size={12} />
              )}
            </button>
            <span className="text-xs min-w-[16px] text-center">
              {item.quantity}
            </span>
            <button
              type="button"
              onClick={handleIncrease}
              disabled={item.quantity >= item.availableQuantity}
              className="w-5 h-5 flex items-center justify-center rounded-full bg-gray-100 hover:bg-gray-200 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              aria-label="Increase quantity"
            >
              <HugeiconsIcon icon={PlusSignIcon} size={12} />
            </button>
          </div>
        </div>
      </div>
      <p className="text-sm font-medium flex-shrink-0 ml-2">
        ₦{(item.price * item.quantity).toLocaleString()}
      </p>
    </div>
  );
}
